"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryInfoToJSON = exports.CountryInfoFromJSONTyped = exports.CountryInfoFromJSON = void 0;
function CountryInfoFromJSON(json) {
    return CountryInfoFromJSONTyped(json, false);
}
exports.CountryInfoFromJSON = CountryInfoFromJSON;
function CountryInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': json['countryCode'],
        'countryName': json['countryName'],
    };
}
exports.CountryInfoFromJSONTyped = CountryInfoFromJSONTyped;
function CountryInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countryCode': value.countryCode,
        'countryName': value.countryName,
    };
}
exports.CountryInfoToJSON = CountryInfoToJSON;
//# sourceMappingURL=CountryInfo.js.map